import Product from './Product'
import { fk } from 'redux-orm'
import { SET_FEATURED_PRODUCTS } from '../redux/actions/featuredProduct'
import camelize from 'camelize'

class FeaturedProduct extends Product {
  static reducer (action, FeaturedProduct) {
    switch (action.type) {
      case SET_FEATURED_PRODUCTS:
        const featuredProducts = action.featuredProducts
        featuredProducts.forEach(product => {
          FeaturedProduct.create(camelize(product))
        })
        break
    }
  }
}

FeaturedProduct.modelName = 'FeaturedProduct'
FeaturedProduct.fields = {
  product: fk('Product', 'featuredProduct')
}

export default FeaturedProduct
